import React, { useState } from 'react';
import { bool } from 'prop-types';
import classNames from 'classnames';

import { usePromoModel } from '../../../../contexts/PromoModelProvider';
import { usePromoCart } from '../../../../contexts/PromoCartProvider';
import { usePromoPresentation } from '../../../../contexts/PromoPresentationProvider';
import { ImagesContainer } from '../ImagesContainer/ImagesContainer';
import { PromoProgress } from '../../../promo-progress/PromoProgress';
import { BmsmTiers } from '../BmsmTiers/BmsmTiers';
import { PromoGoToCart } from '../../../promo-go-to-cart/PromoGoToCart';
import './InfoContainer.scss';

export const InfoContainer = ({ isInPromoDrawer }) => {
  const { isPromoAchieved, promoCartQuantity } = usePromoCart();
  const { isMsb, isBogo, isBmsm } = usePromoModel();
  const { hideImages } = usePromoPresentation();
  const [isLeftFade, setLeftFade] = useState(false);
  const [isRightFade, setRightFade] = useState(false);

  const showFullWidth = isMsb || isBmsm || isInPromoDrawer;
  const showTiers = isBmsm && !promoCartQuantity && !isInPromoDrawer;

  const promoInfoContainerClasses = classNames('promo-info-container', {
    'promo-info-container--full-width': showFullWidth,
    'promo-info-container__fade-effect-left': (isLeftFade && !hideImages),
    'promo-info-container__fade-effect-right': (isRightFade && !hideImages),
    'promo-info-container--no-padding': showTiers,
  });

  return (
    <div className={promoInfoContainerClasses}>
      {(isBogo || isInPromoDrawer) && <ImagesContainer setLeftFade={setLeftFade} setRightFade={setRightFade} />}
      {isMsb && <PromoProgress isInPromoDrawer={isInPromoDrawer} />}
      {isBmsm && (showTiers
        ? <BmsmTiers />
        : <PromoProgress isInPromoDrawer={isInPromoDrawer} />)}
      {(isMsb || isBmsm) && isInPromoDrawer && isPromoAchieved && (
        <div className="promo-info-container__cart-button">
          <PromoGoToCart />
        </div>
      )}
    </div>
  );
};

InfoContainer.displayName = 'InfoContainer';

InfoContainer.propTypes = {
  isInPromoDrawer: bool,
};

InfoContainer.defaultProps = {
  isInPromoDrawer: false,
};
